import axios from "axios";
import axiosInstance from "./axiosInstance";

class EstadoLegislacaoApi {
  cancelTokens = {
    getEstadosLegislacao: null,
  };

  isCancel(exceptionThrown) {
    return axios.isCancel(exceptionThrown);
  }

  async getEstadosLegislacao(enteFederativoId) {
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    this.cancelTokens.getEstadosLegislacao = source;

    const params = {};
    if (enteFederativoId) {
      params.ente_federativo_id = enteFederativoId;
    }

    const { data } = await axiosInstance.get(
      `${process.env.VUE_APP_BASE_API_URL}/api/v1/estados_legislacoes`,
      {
        params,
        cancelToken: source.token,
      }
    );

    this.cancelTokens.getEstadosLegislacao = null;

    return data;
  }
}

export default EstadoLegislacaoApi;
